var _g, _g2, _g3, _g4, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfrodineLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8C00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 150 L120 30 L190 150 L170 150 L150 110 L70 110 L50 150 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 30 L210 150 L280 150 Q320 150 320 90 Q320 30 280 30 L210 30 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 130 L85 125 L95 120 L105 122 L115 118 L125 122 L135 120 L145 122 L155 120 L160 118 L155 115 L150 110 L145 105 L140 100 L135 95 L130 90 L125 85 L120 80 L115 75 L110 70 L105 75 L100 80 L95 85 L90 90 L85 95 L80 100 L75 105 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#32CD32",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 130 L85 125 L95 120 L105 122 L115 118 L125 122 L135 120 L145 122 L155 120 L160 118 L155 115 L150 110 L145 105 L140 100 L135 95 L130 90 L125 85 L120 80 L115 75 L110 70 L105 75 L100 80 L95 85 L90 90 L85 95 L80 100 L75 105 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "white",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 50,
    width: 2,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 50,
    width: 2,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 50,
    width: 2,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 50,
    width: 2,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 50,
    width: 2,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 45,
    width: 25,
    height: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 50,
    rx: 8,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 50,
    width: 4,
    height: 80
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 125,
    rx: 6,
    ry: 3
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 175,
    fontFamily: "Arial, sans-serif",
    fontSize: 36,
    fill: "white",
    textAnchor: "middle"
  }, "AfroDine")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 195,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#FF8C00",
    textAnchor: "middle"
  }, "African delicacies just a click away")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrodineLogo);
export default __webpack_public_path__ + "static/media/afrodine_logo.e5a301a94d6a96e9c2c71e1d580579b1.svg";
export { ForwardRef as ReactComponent };